<template>
  <div class="cart-image">
    <ProductBanner
      :content="banner"
      color="white"
      background="secondary"
      over-image
      x-small
    />
    <VCard
      :to="productLink"
      tile
      variant="flat"
      style="max-height: 95px;"
      :data-testid="productLink?.name"
    >
      <img
        :src="productImageSrc"
        :alt="product.name"
        class="img-responsive img-xs"
        @error="onImageError"
      >
    </VCard>
  </div>
</template>


<script lang="ts" setup>
import imageUtils from '~/utils/format/images'
import ProductBanner from '~/components/base/ProductBanner.vue'
import type { CartProduct } from '~/types/cart'
import { useImageFallback } from '~/composables/useImageFallback'

const { onImageError } = useImageFallback()

interface Props {
  product: CartProduct
  banner?: string | null
}

const props = withDefaults(defineProps<Props>(), {
  banner: null
})

const productImageSrc = computed(() => imageUtils.getVariantImage('thumbnail', props.product.productId))
const productLink = computed(() => {
  if (props.product.slug) {
    return {
      name: 'products-title',
      params: { title: props.product.slug }
    }
  }
  return undefined
})
</script>

<style lang="scss" scoped>
@use '~/assets/scss/settings';
@use 'sass:map';

  .img-xs {
    width: 64px;
  }
  .cart-image {
    .img-responsive {
      border: 1px solid rgb(var(--v-theme-border));
      max-width: 95px;
      max-height: 95px;
      width: 100%;
      height: auto;
    }
     @media #{map.get(settings.$display-breakpoints, 'sm-and-down')} {
       .img-xs {
         min-width: 65px;
         min-height: 65px;
       }
     }
  }
</style>
